import {OutlinedCard} from "../../common/OutlinedCard";
import {getFormattedRoundedDate} from "../../../CommonFunctions";
import React, {useState} from "react";
import {getSortedData} from "../../../../services/TablesService";
import {
    createCsvData,
    DOOR_STATES,
    downloadCsvData,
    FARM_EVENT_TYPES,
    ON_OFF_STATES
} from "../../../../services/FarmService";

export const getLedColorEventType = (value) => {
    switch(value) {
        case 0: return 'Lumière éteinte';
        case 2: return 'Lumière rouge';
        case 3: return 'Lumière verte';
        case 4: return 'Lumière orange';
        case 5: return 'Lumière Handddle';
        case 6: return 'Lumière blue';
        case 7: return 'Lumière blanche';
        default: return 'Lumière changée';
    }
}

export const getEventType = (type, value) => {
    switch (type) {
        case FARM_EVENT_TYPES.ON_OFF: return value === ON_OFF_STATES.ON ? 'Allumage du système' : 'Arrêt du système';
        case FARM_EVENT_TYPES.LED_COLOR: return getLedColorEventType(value);
        case FARM_EVENT_TYPES.OPEN_DOOR: return value === DOOR_STATES.CLOSED ? 'Porte fermée' : 'Ouverture de la porte';
        case FARM_EVENT_TYPES.TEMPERATURE: return (value > 0 ? 'Température : ' + value + '°C' : 'Arrêt du chauffage');
        case FARM_EVENT_TYPES.AIR_EXTRACTION_COMMAND: return 'Extraction de l\'air : ' + value + '%';
        case FARM_EVENT_TYPES.RELAY_COMMAND: return 'Arrêt de l\'imprimante';
        case FARM_EVENT_TYPES.DEHUMIDIFIER: return 'Déshumidificateur ' + (value === 1 ? 'on' : 'off');
        case FARM_EVENT_TYPES.PROFILE: return value !== 0 ? 'Profil activé : ' + value : 'Profil désactivé';
        default: return '--';
    }
};

export const HistoryEventsBlock = (props) => {

    const {historyEvents} = props;

    const [showAutomations, setShowAutomations] = useState(false);

    const keptEvents = historyEvents.filter((event) => event.type !== FARM_EVENT_TYPES.LED_COLOR);
    const sortedHistoryEvents = getSortedData(keptEvents, 'date', 'desc');

    /* Get user value depending on if event is an automatic event or if event has a user */
    const getEventUser = (event) => {
        if(event.is_automatic) {
            return 'Automatique';
        }
        if(event.user) {
            return event.user.firstname + ' ' + event.user.lastname;
        }
        return '--';
    }

    const handleShowAutomations = (showAutomations) => {
        setShowAutomations(showAutomations);
    };

    const exportEvents = () => {
        let csvData = [['date', 'event_type', 'user']];

        for(const event of sortedHistoryEvents.filter(e => !e.is_automatic)){
            const value = event.farm_profile ? event.farm_profile.name : event.value;
            csvData.push([
                getFormattedRoundedDate(new Date(event.date)).toString(),
                getEventType(event.type, value),
                getEventUser(event)
            ])
        }

        downloadCsvData(createCsvData(csvData), 'export_events')
            .catch(() => alert('Une erreur est survenue lors de la création du CSV.'));
    };

    return(
        <OutlinedCard>
            <div className="farm__dialog_history_events">
                <h2>Historique d'événements</h2>
                {/*<div className="toggle">*/}
                {/*    <Toggle checked={showAutomations} onChange={showAutomations => handleShowAutomations(showAutomations)}/>*/}
                {/*    <span className="">Show Smart Farm automations</span>*/}
                {/*</div>*/}
                <button onClick={exportEvents}><i className="fa fa-download"/> Exporter les événements</button>
                {sortedHistoryEvents.length === 0 &&
                    <p>Pas d'historique d'événements</p>
                }
                {sortedHistoryEvents.length > 0 &&
                    <div className="history-events-table">
                        <table>
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th>Type d'événement</th>
                                <th>Utilisateur</th>
                            </tr>
                            </thead>
                            <tbody>
                            {sortedHistoryEvents.filter(e => showAutomations || !e.is_automatic).map(event => {
                                const value = event.farm_profile ? event.farm_profile.name : event.value;
                                return (
                                    <tr key={event.id}>
                                        <td>{getFormattedRoundedDate(new Date(event.date)).toString()}</td>
                                        <td>{getEventType(event.type, value)}</td>
                                        <td>{getEventUser(event)}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </OutlinedCard>
    );
}
